import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EpsShortcutSvg = function EpsShortcutSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#prefix__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#FF9A00",
        fillRule: "evenodd",
        d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#300",
        fillRule: "evenodd",
        d: "M10.488 15h.248v-2.358h1.34c1.386 0 2.309-.756 2.309-2.047 0-1.364-1.049-2.102-2.453-2.102H9.625v4.722A9 9 0 0 1 10.488 15M5.03 9.523v-.09h3.195l.004-.94H3.927v.714q.566.124 1.102.316m5.696 2.242h1.323c.761 0 1.297-.5 1.297-1.234 0-.747-.568-1.174-1.328-1.174h-1.292zm9.644 1.507c0 1.021-.986 1.818-2.543 1.818-1.264 0-2.497-.634-2.646-1.89h1.135c.143.657.747 1.013 1.507 1.013.805 0 1.44-.329 1.44-.932 0-.536-.446-.801-1.112-.945l-1.197-.261c-.972-.198-1.565-.765-1.579-1.714-.009-1.18 1.03-1.949 2.421-1.949 1.625 0 2.484.882 2.498 1.935h-1.108c-.08-.774-.657-1.044-1.376-1.044-.716 0-1.283.351-1.283.936 0 .423.23.666.994.841l1.17.261c1.454.298 1.679 1.243 1.679 1.931",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "currentColor",
        d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "prefix__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var EpsShortcut = function EpsShortcut(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: EpsShortcutSvg
  }));
};